import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import styles from './standard-image.scss';
import { isMobile, isTablet } from '../../../common';

export const imageSizes = {
    mobile: '320px',
    tablet: '640px',
    tabletWithActiveNav: '478px',
};

export const getImageSize = (isNavigationActive) => {
    let imageSize = imageSizes.tablet;
    if (isMobile()) {
        imageSize = imageSizes.mobile;
    } else if (isTablet() && isNavigationActive) {
        imageSize = imageSizes.tabletWithActiveNav;
    }
    return imageSize;
};

class StandardImage extends Component {
    static propTypes = {
        imageUrl: PropTypes.string,
        isNavigationActive: PropTypes.bool,
        isFullWidth: PropTypes.bool,
    };

    static defaultProps = {
        isNavigationActive: false,
        isFullWidth: false,
    };

    constructor(props) {
        super(props);

        this.state = { imageSize: imageSizes.tablet }
    }

    componentDidMount() {
        if (this.props.imageUrl) {
            window.addEventListener('resize', this.resizeImage);
            this.resizeImage(this.props.isNavigationActive);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isNavigationActive !== nextProps.isNavigationActive) {
            this.resizeImage(nextProps.isNavigationActive);
        }
    }

    componentWillUnmount() {
        if (this.props.imageUrl) {
            window.removeEventListener('resize', this.resizeImage);
        }
    }

    resizeImage = (isNavigationActive) => {
        this.setState({ imageSize: getImageSize(isNavigationActive) });
    };

    render() {
        const { imageUrl, isFullWidth } = this.props;
        const { imageSize } = this.state;
        const imageWidth = isFullWidth ? '100%' : imageSize;

        const inlineStyles = {
            backgroundImage: imageUrl && `url(${ imageUrl })`,
            width: imageUrl && imageWidth,
            height: imageUrl && imageSize,
            margin: '0 auto',
        };

        return (
            <div id="standardImage" styleName="wrapper" style={inlineStyles} />
        )
    }
}

export default CSSModules(StandardImage, styles);


// WEBPACK FOOTER //
// ./app/components/shared/StandardImage/index.jsx